import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import ManageAccount from './ManageAccount';
import RoutedHeader from '../Header';

import {
  fetchAccountCashBalanceWithOfferingOrders,
} from '../../actions';

const Big = require('big.js/big.js');

class ManageAccountContainer extends Component {
  componentDidMount() {
    this.props.fetchAccountCashBalanceWithOfferingOrders(this.props.accountNumber);
  }
  render() {
    const {
      accountNumber,
      cashBalance,
      balanceWithheld,
      pendingTransfers,
      suitabilityInformationId,
    } = this.props;

    const propsToPassToChildren = {
      accountNumber,
      cashBalance,
      balanceWithheld: balanceWithheld ?
        Number.parseFloat(Big(balanceWithheld).times(-1).round(2, 0)) : 0,
      pendingTransfers,
      suitabilityInformationId,
    };

    return (
      <div>
        <RoutedHeader />
        <ManageAccount {...propsToPassToChildren} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceBeforeCurrentActivity')),
  balanceWithheld: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceWithheldFromT1Trades')),
  pendingTransfers: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.pendingTransfers')),
  suitabilityInformationId: get(state, 'user.data.suitabilityInformationId'),
});

const mapDispatchToProps = {
  fetchAccountCashBalanceWithOfferingOrders,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageAccountContainer);



// WEBPACK FOOTER //
// ./src/components/ManageAccount/index.js